import { POLYGON_PREVIEW } from "common-client/utils/objectTypePreviewIcon/iconPaths";
import { PolygonIconProps } from "common-client/utils/objectTypePreviewIcon/types";

const PolygonIcon = ({
  fillColor,
  fillOpacity,
  lineColor,
  lineOpacity,
  lineWidth,
  size = 13,
}: PolygonIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox={POLYGON_PREVIEW.viewBox}
    fill="none"
    style={{ filter: "drop-shadow(0px 1px 1.5px rgba(0, 0, 0, 0.2))" }}
  >
    <path
      d={POLYGON_PREVIEW.path}
      fill={fillColor}
      fillOpacity={fillOpacity}
      stroke={lineColor}
      strokeOpacity={lineOpacity}
      strokeWidth={Math.max(lineWidth, 1)}
      strokeLinejoin="round"
    />
  </svg>
);

export default PolygonIcon;
